import { Collapse } from 'antd';
import styled from 'styled-components';
import Media from '../../utils/media';

/* -------------------------- FAQs --------------------------- */
export const FAQsStyled = styled.div`
  margin-top: 70px;

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    max-width: ${Media.SIZE.MD}px;
    padding: 10px 15px;
    margin-top: unset;
  }
`;

export const FAQsTitleStyled = styled.div`
  font-family: SVN-GilroyMedium;
  font-size: 40px;
  font-weight: 700;
  text-align: center;

  ${Media.lessThan(Media.SIZE.XS)} {
    content: 'Media.SIZE.XS';

    font-size: 30px;
    font-weight: 700;
    text-align: center;
    padding-top: 30px;
    padding-bottom: 30px;
    /* font-style: italic;
    text-decoration: underline; */
  }
`;

export const FAQsListStyled = styled.div`
  display: flex;
  margin: 0px auto;
  width: calc(100% - 95px * 2);
  padding-top: 45px;
  justify-content: space-between;

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.MD';
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    display: flex;
    flex-direction: column;
    margin: 0px auto;
    width: 100%;
    padding-top: 15px;
  }
`;

export const FAQsItemStyled = styled.div`
  width: calc((100%));
  border-radius: 10px;
  display: flex;
  height: fit-content;

  .ant-collapse-item {
    height: max-content;

    .ant-collapse-header {
      align-items: center !important;
      height: max-content;
    }
  }
  &:not(:first-child) {
    margin-top: 20px;
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.MD';

    &:not(:first-child) {
      margin-top: 20px;
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    width: 100%;
    max-width: initial;
    border-radius: 10px;
    display: flex;
    height: max-content;
    flex: unset;
  }
`;

export const ColStyled = styled.div`
  width: calc((100% - 25px) / 2);

  ${Media.lessThan(Media.SIZE.MD)} {
    width: 100%;

    &:last-child {
      margin-top: 25px;
    }
  }
`;

export const CollapseStyled = styled(Collapse)<any>`
  width: 100%;
  font-family: ${(props) => (props.lang === 'zh' ? 'Roboto' : 'Inter')};

  .ant-collapse-header-text {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
  }

  .ant-collapse-content-box {
    font-size: 16px;
    font-weight: 300;
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    width: 100%;

    .ant-collapse-header-text {
      font-size: 16px;
      font-weight: 500;
      text-align: left;
    }

    .ant-collapse-content-box {
      font-size: 14px;
      font-weight: 300;
    }
  }
`;
